import axios from "axios";
import { getStoredToken, getStoredOrgSlug } from "../context/AuthContext";
import { logApiError } from "../utils/apiDebugLog";

const BASE_URL = "/api";

const api = axios.create({
  baseURL: BASE_URL,
  timeout: 15000,
  headers: { "Content-Type": "application/json" },
});

// Attach JWT and X-Tenant-Slug on every request
api.interceptors.request.use((config) => {
  const token = getStoredToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  // Inject org slug so the server can resolve the tenant on all requests
  // (including public routes like GET /config)
  const slug = getStoredOrgSlug();
  if (slug) {
    config.headers["X-Tenant-Slug"] = slug;
  }
  return config;
});

// Standardise error shape
api.interceptors.response.use(
  (res) => res,
  (err) => {
    // Dispatch auth:expired for 401s outside of the login endpoint so
    // AuthContext can clear the session and redirect to login.
    if (
      err.response?.status === 401 &&
      !err.config?.url?.includes("/auth/login")
    ) {
      window.dispatchEvent(new CustomEvent("auth:expired"));
    }

    const message =
      err.response?.data?.message ??
      err.response?.data?.error ??
      err.message ??
      "An unexpected error occurred";

    logApiError({
      method: (err.config?.method ?? "unknown").toUpperCase(),
      url: err.config?.url ?? "unknown",
      requestBody: err.config?.data ? JSON.parse(err.config.data) : undefined,
      status: err.response?.status,
      responseBody: err.response?.data,
      errorMessage: message,
    });

    return Promise.reject(new Error(message));
  }
);

export default api;
